(function ($, Cobalt, undefined) {
    Cobalt.UserSurrogateAvatars = {
        initialize: function () {
            var avatarSelection = $(".avatar-select");

            if (avatarSelection.length > 0) {

                var userSurrogates = avatarSelection.find("#field-user-surrogates");
                var modelIDPair = Cobalt.UserSurrogateAvatars.getActiveSurrogateModelIDPair(userSurrogates.val());                
                var entityTypeID = modelIDPair[0];
                var entityID = modelIDPair[1];
                Cobalt.UserSurrogateAvatars.hideAvatars(entityTypeID, entityID);
                if (userSurrogates.length > 0) {

                    var eventData = { avatarSelection: avatarSelection };
                    userSurrogates.bind("change", eventData, Cobalt.UserSurrogateAvatars.userSurrogateChanged);

                    var idPair = Cobalt.UserSurrogateAvatars.getIDPairHash();
                    if (idPair != "") {
                        userSurrogates.val(idPair);
                        userSurrogates.trigger("change");
                    }
                }

                avatarSelection.find(".avatar-link").click(function (event) {
                    event.preventDefault();
                    var selectedAvatar = avatarSelection.find(".avatar-selected");
                    if (selectedAvatar.length > 0) {
                        selectedAvatar.removeClass("avatar-selected");
                    }
                    $(this).parent().addClass("avatar-selected");

                    // Ajax post
                    var $this = $(this);
                    var href = $this.attr('href');

                    modelIDPair = Cobalt.UserSurrogateAvatars.getActiveSurrogateModelIDPair(avatarSelection.find("#field-user-surrogates").val());
                    Cobalt.Core.withRequestVerificationToken(function (requestVerificationToken) {
                        $.ajax({
                            type: 'POST',
                            url: href,
                            cache: false,
                            data: { "request-verification-token": requestVerificationToken },
                            success: function () {
                                Cobalt.UserSurrogateAvatars.getUpdatedUserSurrogateAvatars(avatarSelection, modelIDPair[0], modelIDPair[1]);
                            }
                        })
                    });
                });

                avatarSelection.find(".disable-avatar").click(function (event) {
                    event.preventDefault();

                    // Ajax post
                    var $this = $(this);
                    var href = $this.attr('href');

                    modelIDPair = Cobalt.UserSurrogateAvatars.getActiveSurrogateModelIDPair(avatarSelection.find("#field-user-surrogates").val());

                    Cobalt.Core.withRequestVerificationToken(function (requestVerificationToken) {
                        $.ajax({
                            type: 'POST',
                            url: href,
                            cache: false,
                            data: { "request-verification-token": requestVerificationToken },
                            success: function () {
                                Cobalt.UserSurrogateAvatars.getUpdatedUserSurrogateAvatars(avatarSelection, modelIDPair[0], modelIDPair[1]);
                            }
                        })
                    });
                });
            }
        },
        userSurrogateChanged: function (event) {
            var avatarSelection = event.data.avatarSelection;
            var modelIDPair = Cobalt.UserSurrogateAvatars.getActiveSurrogateModelIDPair($(this).val());
            if (modelIDPair.length == 2) {
                var entityTypeID = modelIDPair[0];
                var entityID = modelIDPair[1];
                if (entityTypeID > 0 && entityID > 0) {
                    Cobalt.UserSurrogateAvatars.getUpdatedUserSurrogateAvatars(avatarSelection, entityTypeID, entityID);

                    var avatars = avatarSelection.find(".avatar");
                    avatars.each(function (i, val) {
                        var avatarID = $(val).attr("data-avatar-id");
                        var link = $(val).find("a.avatar-link");
                        if (link.length > 0) {
                            link.attr("href", Cobalt.Routes.Instance.AvatarActivateAvatar({ entityTypeID: entityTypeID, entityID: entityID, avatarID: avatarID }));
                        }
                    });

                    Cobalt.UserSurrogateAvatars.setIDPairHash(entityTypeID, entityID);
                    Cobalt.UserSurrogateAvatars.updateUploadForm(entityTypeID, entityID);
                    Cobalt.UserSurrogateAvatars.updateDeleteLinks(entityTypeID, entityID);
                }
            }
        },
        setIDPairHash: function (entityTypeID, entityID) {
            var hash = self.location.hash;
            var idPair = Cobalt.UserSurrogateAvatars.getIDPairHash();
            var newIDPair = "{0}:{1}".format(entityTypeID, entityID);
            //$.log("hash: {0}; idPair: {1}; newIDPair: {2}".format(hash, idPair, newIDPair));
            if (idPair != "") {
                hash = hash.toString().replace(idPair, newIDPair);
            }
            else {
                hash += ";" + newIDPair;
            }
            self.location.hash = hash;
        },
        getIDPairHash: function () {
            var hash = self.location.hash;
            var idPair = "";
            if (hash != "") {
                var regExp = /\d+\:\d+/;
                var match = regExp.exec(hash);
                if (match && match.length > 0) {
                    idPair = match[0];
                }
            }
            return idPair;
        },
        updateUploadForm: function (entityTypeID, entityID) {
            var avatarForm = $(".avatar-form");
            if (avatarForm.length > 0) {
                var actionUrl = Cobalt.Routes.Instance.AvatarUploadAvatar(entityTypeID, entityID, { returnUrl: self.location.host + self.location.hash });
                avatarForm.attr("action", actionUrl);
            }
        },
        updateDeleteLinks: function (entityTypeID, entityID) {
            $("a.user-avatar-delete-link").each(function (i, val) {
                $(val).attr("href", Cobalt.Routes.Instance.AvatarDeleteAvatar({ entityTypeID: entityTypeID, entityID: entityID, avatarID: $(val).parents("li").attr("data-avatar-id") }));
            });
        },
        getUpdatedUserSurrogateAvatars: function (avatarSelection, entityTypeID, entityID) {
            var currentAvatar = avatarSelection.find(".current-avatar");
            if (currentAvatar.length > 0) {
                currentAvatar.mask();
                $.ajax({
                    url: Cobalt.Routes.Instance.UserGetUserSurrogateShortDetails({ entityTypeID: entityTypeID, entityID: entityID }),
                    dataType: 'json',
                    cache: false,
                    success: function (result) {
                        var avatarID = result.avatarID;
                        var fallbackAvatarUrl = result.fallbackAvatarUrl;
                        currentAvatar.attr("data-avatar-id", avatarID);
                        currentAvatar.html(result.html);

                        var selectedAvatar = avatarSelection.find(".avatar-selected");
                        if (selectedAvatar.length > 0) {
                            selectedAvatar.removeClass("avatar-selected");
                        }

                        var fallbackAvatar = $("#fallback-avatar");
                        if (fallbackAvatar.length > 0) {
                            fallbackAvatar.attr("src", fallbackAvatarUrl);
                        }
                        if (avatarID > 0) {
                            var avatar = avatarSelection.find(".avatar[data-avatar-id='" + avatarID + "']");
                            if (avatar.length > 0) {
                                avatar.addClass("avatar-selected");
                            }
                            else {
                                fallbackAvatar.parents("li").addClass("avatar-selected");
                            }
                        } else {
                            fallbackAvatar.parents("li").addClass("avatar-selected");
                        }
                        currentAvatar.unmask();
                        Cobalt.UserSurrogateAvatars.hideAvatars(entityTypeID, entityID);
                        Cobalt.UserSurrogateAvatars.resetDisableAvatar(entityTypeID, entityID);
                    }
                });
            }
        },
        getActiveSurrogateModelIDPair: function (selectedSurrogateValue) {
            return selectedSurrogateValue.split(":");
        },
        hideAvatars: function (entityTypeID, entityID) {
            $(".user-avatars .avatar").each(function (i, val) {
                var avatarTypeID = $(val).attr("data-entity-type-id");
                var avatarEntityID = $(val).attr("data-entity-id");
                var isGenerated = $(val).attr("data-is-generated");

                //$.log("entityTypeID: {0}, avatarTypeID: {1}, entityID: {2}, avatarEntityID: {3}, isGenerated: {4}".format(entityTypeID, avatarTypeID, entityID, avatarEntityID, isGenerated));
                //$.log(isGenerated == "true" && (entityTypeID == avatarTypeID && entityID != avatarEntityID));
                if (isGenerated == "true" && ((entityTypeID == avatarTypeID && entityID != avatarEntityID) || (entityTypeID != avatarTypeID))) {
                    $(val).hide();
                }
                else {
                    $(val).show();
                }
            });
        },
        resetDisableAvatar: function (entityTypeID, entityID) {
            var url = Cobalt.Routes.Instance.AvatarDisableAvatar({ entityTypeID: entityTypeID, entityID: entityID });
            var disableAvatarLink = $(".disable-avatar");
            if (disableAvatarLink.length > 0) {
                disableAvatarLink.attr("href", url);
            }
        },     
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.UserSurrogateAvatars.js